/* eslint-disable react/prop-types */
import React from 'react';
import { Button } from 'react-native-elements-light';
import {
  button,
  buttonLilla,
  buttonText,
  buttonDisabled,
  buttonTextDisabled,
} from '~assets/styles/buttonStyles';
import { isWeb } from '~global/screens';
const ButtonDefault = (props) => {
  const buttonDisabledStyle = { ...button, ...buttonDisabled };
  const buttonTextDisabledStyle = { ...buttonText, ...buttonTextDisabled };
  const webStyle = { cursor: isWeb ? 'pointer' : 'default' };
  return (
    <Button
      {...props}
      containerStyle={[props.containerStyle, webStyle]}
      buttonStyle={[button, buttonLilla, props.buttonStyle, webStyle]}
      titleStyle={[buttonText, props.titleStyle]}
      disabledStyle={[buttonDisabledStyle, props.disabledStyle]}
      disabledTitleStyle={[buttonTextDisabledStyle, props.disabledTitleStyle]}
    />
  );
};

export default ButtonDefault;
